import router from "@/app/router";
import { useAuthStore } from "@/auth/stores/auth";
import { getCurrentAccount } from "@/shared/utils/sessionStorage.utils";

export const hasRoleAccessToRoute = (pathName: string, params = {}, query = {}) => {
  const currentAccount = getCurrentAccount();

  const to = router.resolve({
    name: pathName,
    params,
    query,
  });
  const accessRoles = to.matched.reduce<string[]>((acc, r) => {
    const routeRoles = Array.isArray(r.meta.accessRoles) ? (r.meta.accessRoles as string[]) : [];

    return [...acc, ...routeRoles];
  }, []);
  const role = useAuthStore().getRoleName || currentAccount?.role || null;

  if (Array.isArray(accessRoles) && accessRoles.length > 0) {
    const hasRole = accessRoles.includes(role);
    return hasRole;
  }
  return true;
};

export const hasRoleAccessToAction = (requiredRoles: string[]): boolean => {
  const userRole = useAuthStore().getRoleName;
  return requiredRoles.includes(userRole);
};
